import _ from 'lodash';
import { getProviderFormService } from '../../helper';

export const getProviderRefillDays = (providerServiceId, providerForm) => {
  if (providerServiceId && providerForm) {
    const service = getProviderFormService(providerServiceId, providerForm);
    if (service?.service_refill_days) {
      return service.service_refill_days;
    }
  }
  return null;
};

export const getRefillValue = (refill_days) => {
  if (_.isNull(refill_days) || refill_days === '') {
    return '';
  }
  if (refill_days) {
    return refill_days;
  }
};

export const disableRefillDays = (providerServiceId, providerForm, refillType) => {
  if (providerServiceId && refillType && providerForm) {
    if (refillType === 1) {
      const providerRefillDays = getProviderRefillDays(providerServiceId, providerForm);
      if (providerRefillDays) {
        return true;
      }
    }
  }
  return false;
};
